class Checkout {
	constructor() {
		this.installListeners();
		this.updateQuantityFields();
	}

	installListeners() {
		const self = this;

		jQuery(document.body).on( 'updated_checkout', function(){
			self.updateQuantityFields();
			self.unblockShopList();
		});

		jQuery(document.body).on( 'update_checkout', function(){
			self.blockShopList();
		});
	}

	updateQuantityFields() {
		const debouncedUpdateQuantityFields = Helpers.debounce(() => {
			this.updateProductsQuantity();
		}, 1000);

		document.querySelectorAll('.custom-quantity').forEach(el => {
			new CustomQuantity(el);

			el.addEventListener('quantityChange', () => {
				debouncedUpdateQuantityFields();
			});
		});
	}

	blockShopList() {
		jQuery('.shop-list').block({
			message: null,
			overlayCSS: {
				background: "#fff",
				opacity: 0.6
			}
		});
	}

	unblockShopList() {
		jQuery('.shop-list').unblock();
	}

	updateProductsQuantity() {
		const formData = new FormData();
		const productsData = [];
		const cartItems = document.querySelectorAll('.shop-list .cart_item');

		cartItems.forEach(item => {
			const quantity = item.querySelector('.custom-quantity').getAttribute('data-quantity');

			productsData.push({
				cart_item_key: item.getAttribute('data-cart-item-key'),
				quantity
			});
		});

		formData.append('cart_items', JSON.stringify(productsData));
		formData.append('action', 'set_product_quantity');
		formData.append('security', globalSettings.nonce);

		// Send formData to server

		this.blockShopList();

		fetch(globalSettings.ajax_url, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then(obj => {
				console.log(obj);
			})
			.catch(error => {
				console.error(error);
			}).finally(() => {
				this.unblockShopList();
				jQuery( document.body ).trigger( 'update_checkout' );
			});
	}
}


addEventListener('DOMContentLoaded', function () {
	new Checkout();
});